(function(window, iFrameBridgeDefinition) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.iFrameBridge = iFrameBridgeDefinition(window, window.JSON, namespace.playerConfiguration);
})(this, function(window, JSON, playerConfiguration) {
   'use strict';

   var postMessage = function(eventName, domain, data) {
      var message = {};
      message.smartPlayerEventName = eventName;
      if (playerConfiguration.getEmbedIFrameId()) {
         message.iFrameId = playerConfiguration.getEmbedIFrameId();
      }
      if (data) {
         message.data = data;
      }
      window.top.postMessage(JSON.stringify(message), domain);
   };

   var isInIframe = function() {
      return window !== window.top;
   };

   return {
      postMessage: postMessage,
      isInIframe: isInIframe
   };
});
